import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Lightbox from 'react-images';
import styled from 'styled-components'

import style from '../utils/styles'
import { rhythm } from '../utils/typography'

const Thumbnail = styled.a `
  box-sizing: border-box;
  display: block;
  float: left;
  line-height: 0;
  padding-right: ${rhythm(0.25)};
  padding-bottom: ${rhythm(0.25)};
  overflow: hidden;

  @media (min-width: 500px) {
    padding-right: ${rhythm(0.5)};
    padding-bottom: ${rhythm(0.5)};
  }
`

const Gal = styled.div`
  margin-right: -${rhythm(0.25)};
  overflow: hidden;

  @media (min-width: 500px) {
    marginRight: -${rhythm(0.5)};
  }
`

const Source = styled.img`
  border: 0;
  display: block;
  height: auto;
  max-width: 100%;
  width: auto;
`

class Gallery extends Component {
  constructor () {
    super();

    this.state = {
      lightboxIsOpen: false,
      currentImage: 0,
    };

    this.closeLightbox = this.closeLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
    this.gotoImage = this.gotoImage.bind(this);
    this.handleClickImage = this.handleClickImage.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
  }
  openLightbox (index, event) {
    event.preventDefault();
    this.setState({
      currentImage: index,
      lightboxIsOpen: true,
    });
  }
  closeLightbox () {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  }
  gotoPrevious () {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }
  gotoNext () {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }
  gotoImage (index) {
    this.setState({
      currentImage: index,
    });
  }
  handleClickImage () {
    if (this.state.currentImage === this.props.images.length - 1) return;

    this.gotoNext();
  }
  renderGallery () {
    const { images } = this.props;

    if (!images) return;

    const g = images.map((obj, i) => {
      return (
        <Thumbnail
          href={obj.src}
          key={i}
          onClick={(e) => this.openLightbox(i, e)}
        >
          <Source src={obj.thumb} />
        </Thumbnail>
      );
    });

    return (
      <Gal>
        {g}
      </Gal>
    );
  }
  render () {
    return (
      <div className="section">
        {this.props.heading && <h2>{this.props.heading}</h2>}
        {this.props.subheading && <p>{this.props.subheading}</p>}
        {this.renderGallery()}
        <Lightbox
          currentImage={this.state.currentImage}
          images={this.props.images}
          isOpen={this.state.lightboxIsOpen}
          onClickImage={this.handleClickImage}
          onClickNext={this.gotoNext}
          onClickPrev={this.gotoPrevious}
          onClickThumbnail={this.gotoImage}
          onClose={this.closeLightbox}
          showThumbnails={this.props.showThumbnails}
          theme={this.props.theme}
        />
      </div>
    );
  }
}



export default Gallery;



// WEBPACK FOOTER //
// ./src/layouts/gallery.js